// src/frontend/js/modern/shared/validators.js

export const validators = {
	isValidEmail(email) {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	},

	// ---- Added helpers ----
	isCookieEnabled() {
		if (navigator.cookieEnabled) return true;
		document.cookie = 'cookietest=1';
		const ret = document.cookie.indexOf('cookietest=') !== -1;
		document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
		return ret;
	},

	setCookie(name, value, days = 365 * 25) {
		const date = new Date();
		date.setDate(date.getDate() + days);
		document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + date.toUTCString() + "; path=/";
	},

	getCookie(name) {
		const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) return decodeURIComponent(match[2]);
		return null;
	},

	isTrue(value) {
		return value === true || value === 'yes' || value === '1' || value === 1 || value === 'true';
	},

	isOS() {
		return navigator.userAgent.match(/ipad|iphone/i);
	},

	updateURLParameter(url, param, paramVal) {
		const tempArray = url.split('?');
		const baseURL = tempArray[0];
		let additionalURL = tempArray[1] || '';
		let newAdditionalURL = '';
		let temp = '';
		if (additionalURL) {
			const items = additionalURL.split('&');
			for (let i = 0; i < items.length; i++) {
				if (items[i].split('=')[0] !== param) {
					newAdditionalURL += temp + items[i];
					temp = '&';
				}
			}
		}
		const rows_txt = temp + '' + param + '=' + paramVal.replace('#', '');
		return baseURL + '?' + newAdditionalURL + rows_txt;
	},

	getUrlParameter(url, sParam) {
		const sPageURL = decodeURIComponent(url.substring(1));
		const sURLVariables = sPageURL.split(/[&|?]+/);
		for (let i = 0; i < sURLVariables.length; i++) {
			const sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
		return null;
	},
};

export default validators;
